import { useState, type FormEvent } from "react";
import { Link, Navigate, useSearchParams } from "react-router";
import { useAuth } from "../auth.tsx";
import { useAction } from "../api.ts";
import { Button, ErrorText, Field, Input } from "../ui/index.tsx";
import { AuthLayout } from "../layouts.tsx";

export default function Register() {
  const { me, register } = useAuth();
  const [params] = useSearchParams();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [referral, setReferral] = useState(params.get("ref") ?? "");
  const [mismatch, setMismatch] = useState(false);

  const submit = useAction(async () => { await register(username.trim(), password, referral.trim()); });

  const next = params.get("next");
  if (me) return <Navigate to={next?.startsWith("/") && !next.startsWith("//") ? next : "/home"} replace />;

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (password !== confirm) { setMismatch(true); return; }
    setMismatch(false);
    void submit.run();
  };

  return (
    <AuthLayout title="Create your account" subtitle="Takes a few seconds. No email needed."
      footer={<>Already have an account? <Link to={next ? `/login?next=${encodeURIComponent(next)}` : "/login"} className="text-accent hover:underline">Sign in</Link></>}>
      <form onSubmit={onSubmit} className="space-y-4">
        <Field label="Username" hint="3 to 32 characters: letters, numbers, . _ -">
          <Input autoComplete="username" autoFocus required minLength={3} maxLength={32} pattern="[A-Za-z0-9_.\-]{3,32}" value={username} onChange={(e) => setUsername(e.target.value)} />
        </Field>
        <Field label="Password" hint="8 to 128 characters">
          <Input type="password" autoComplete="new-password" required minLength={8} maxLength={128} value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <Field label="Confirm password" error={mismatch ? "Passwords don't match" : null}>
          <Input type="password" autoComplete="new-password" required minLength={8} maxLength={128} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
        </Field>
        <Field label="Referral code (optional)">
          <Input value={referral} onChange={(e) => setReferral(e.target.value)} className="font-mono" />
        </Field>
        <ErrorText>{submit.error}</ErrorText>
        <Button type="submit" variant="primary" size="lg" className="w-full" loading={submit.pending}>Create account</Button>
      </form>
    </AuthLayout>
  );
}
